import { gql } from "@apollo/client";

export const analyticsDashboardQuery = gql`
  query AnalyticsDashboard(
    $period: AnalyticsPeriodEnum!
    $startDate: Date
    $endDate: Date
    $channel: String
    $slot: String
  ) {
    analytics(
      period: $period
      startDate: $startDate
      endDate: $endDate
      channel: $channel
      slot: $slot
    ) {
      period
      startDate
      endDate
      channel
      slot
      currency
      sales {
        totalRevenue
        totalOrders
        totalExpenses
        averageOrderValue
        grossProfit
        netProfit
        trends {
          date
          revenue
          ordersCount
          expenses
          netProfit
        }
      }
      products {
        bestSelling {
          productId
          productName
          variantName
          quantitySold
          revenue
          cost
          grossMargin
          marginPercentage
        }
        slowMoving {
          productId
          productName
          variantName
          quantitySold
          revenue
          cost
          grossMargin
          marginPercentage
        }
        highMargin {
          productId
          productName
          variantName
          quantitySold
          revenue
          cost
          grossMargin
          marginPercentage
        }
        lowPerforming {
          productId
          productName
          variantName
          quantitySold
          revenue
          cost
          grossMargin
          marginPercentage
        }
        allProducts {
          productId
          productName
          variantName
          quantitySold
          revenue
          cost
          grossMargin
          marginPercentage
        }
      }
      customers {
        totalCustomers
        newCustomersCount
        returningCustomersCount
        retentionRatePercentage
        averageCustomerLifetimeValue
        purchaseFrequency
        topCustomers {
          customerId
          name
          email
          phone
          ordersCount
          totalSpend
          averageOrderValue
          lastOrderDate
        }
      }
      inventory {
        totalInventoryValue
        totalStockUnits
        totalAllocatedUnits
        sellThroughRatePercentage
        lowStockAlerts {
          productId
          productName
          variantName
          stockQuantity
          allocatedQuantity
          warehouseName
        }
        fastMoving {
          productId
          productName
          quantitySold
          currentStock
          velocityStatus
        }
        slowMoving {
          productId
          productName
          quantitySold
          currentStock
          velocityStatus
        }
      }
      finance {
        totalIncome
        totalExpenses
        netProfitLoss
        refundsAmount
        canceledOrdersAmount
        refundsCount
        canceledOrdersCount
        paymentBreakdown {
          method
          amount
          ordersCount
        }
        dailyLedger {
          date
          completedSales
          income
          expenses
          refunds
          netBalance
          ordersCount
        }
      }
    }
  }
`;
